{
  "addToContacts": "Legg til i kontakter",
  "addToResourceBase": "Legg til i ressursbasen",
  "areYouSureClose": "Er du sikker på at du vil lukke",
  "backToOpportunities": "Tilbake til henvendelser",
  "board.minimizeColumn": "Minimer kolonne",
  "button.addService": "Legg til tjeneste",
  "button.Forward": "Send videre",
  "button.RecommendService": "Anbefal tjeneste",
  "button.RegisterService": "Registrer tjeneste",
  "actionbar.StartEmailThread": "Send ny epost",
  "actionbar.RecommendService": "Anbefal tjeneste",
  "actionbar.DeliverService": "Lever tjeneste",
  "actionbar.AddNote": "Lag notat",
  "actionbar.ProgramAdmission": "Ta opp",
  "actionbar.Refer": "Henvis videre",
  "card.ReadNoteFrom": "Les notatet fra {{collaborator}} under aktivitetslogg-fanen",
  "chooseForwardRecipient": "Velg hvem som skal bli tilsendt denne henvendelsen",
  "chooseMunicipality": "Velg kommune",
  "chooseProviderType": "Velg aktørtype",
  "chooseRecommendedServices": "Velg hvilke tjenester dere ønsker å anbefale",
  "chooseRegisterServices": "Velg hvilke tjenester dere ønsker å tilby",
  "chosenServices.plural": "valgte tjenester",
  "chosenServices.singular": "valgt tjeneste",
  "chooseServiceType": "Velg bransje",
  "closeReason.Other": "Annet",
  "closeReason.SentInError": "Henvist feil",
  "collaboration.AlreadySharedWithAll": "Du har delt denne henvendelsen med alle aktører.",
  "collaboration.BeginCollaboration": "Start samarbeid",
  "collaboration.InCollaborationCheckLog": "I samarbeid med {{collaborationActors}}. Se aktivitetslogg.",
  "collaboration.IntroText": "Du kan starte samarbeid med flere aktørerer. Når henvendelsen deles vil de aktørene få tilgang til den. Notatet vil vises under fanen \"Aktivitetslogg\".",
  "collaboration.toast.Error": "Kunne ikke starte samarbeid. Vennligst prøv på nytt.",
  "collaboration.toast.Pending": "Starter samarbeid...",
  "collaboration.toast.Success": "Samarbeidet er startet.",
  "closedOpportunitiesFoundInArchive": "Lukkete henvendelser finner du i arkivet.",
  "contactAlreadyExists": "Kontakten finnes allerede i ressursbasen.",
  "countyView.NoteOpportunitiesCanOnlyBeHandled": "Henvendelser kan kun behandles i kommunevisningen.",
  "countyWarning": "For å hjelpe oss å henvise kunder til riktige aktører, har vi laget en side for å samle tilbakemeldinger. For å rapportere om riktig/feil henvisning, vennligst gå til",
  "customerInformation.GoToContact": "Gå til kontakt",
  "customerInformation.GoToMember": "Gå til medlem",
  "customerInformation.Info.AddedContact": "Du la til {{contactName}} i ressursbasen.",
  "customerInformation.Info.AddedContactAndMember": "Du la til {{contactName}} med {{memberName}} i ressursbasen.",
  "customerInformation.PostError": "Noe feilet ved registrering i ressursbasen. Prøv igjen og ta kontakt hvis feilen fortsetter.",
  "details.Archived.Header": "Hendelsen er arkivert",
  "details.Archived.Message": "I tilfelle er det behov for ny henvising, å legge til et notat eller anbefaling av tjenester, kan henvendelsen gjenåpnes igjen. Ved å gjenåpne henvendelsen, blir den tildelt til deg som nåværende rådgiver.",
  "details.AddNote.Error.Title": "Det har oppstått en feil",
  "details.AddNote.Error.Message": "Notatet kan ikke lagres. Prøv gjerne på nytt eller kontakt oss på ",
  "details.AddNode.Intro": "Alle notatene lagres i aktivitetslogg og vises til andre aktører.",
  "details.AddNote.Required": "Notatfeltet kan ikke være tomt",
  "details.AddNote.Success.Message": "Notatet er lagret",
  "details.Referral.Header": "Henvisning til andre aktører",
  "details.Referral.NoneChosen": "Du må velge en aktør for å henvise henvendelsen videre.",
  "details.Referral.ReferToSelectedProviders": "Henvendelsen vil bli sendt til følgende aktører:",
  "details.Referral.Actor.TextAreaField.Required": "Melding til aktører *",
  "details.Referral.Actor.TextAreaField.errorMessage": "Vennligst skriv en melding til mottakere. Aktørene vil bli varslet om henvendelsen via e-post.",
  "details.Referral.Actor.QueryData.isError": "Det har oppstått en feil.",
  "details.Referral.Actor.QueryData.isSuccess": "Henvendelse er henvist videre.",
  "details.Referral.Table.RowSelectedText_zero": "Du må velge en aktør for å henvise henvendelsen videre",
  "details.Referral.Table.RowSelectedText_one": "{{count}} aktør er valgt",
  "details.Referral.Table.RowSelectedText_other": "{{count}} aktører er valgt",
  "details.Referral.Table.RowSelectedText": "aktør er valgt",
  "details.Referral.Table.RowsSelectedText": "aktører er valgt",
  "details.Title.ActivityLog": "Aktivitetslogg",
  "details.Title.Archiving": "Arkiver",
  "details.Title.Inquiry": "Henvendelse",
  "details.Title.Referrer": "Henvis videre",
  "details.Title.Services": "Tjenester",
  "details.Title.CompanyInfo": "Bedriftsinfo",
  "companyInfo.viewInCustomerRegistry": "Vis i kunderegisteret",
  "details.Title.CustomerFollowUp": "Kundeoppfølging",
  "details.Title.CustomerCommunication": "E-post til kunde",
  "documentTitleOpportunities": "Henvendelser - Flerbedriftsportalen",
  "documentTitleOpportunityDetails": "Henvendelse detaljer - Flerbedriftsportalen",
  "doYouWantToAddOrganizationAsLead": "Vil du legge til denne organisasjonen som et lead?",
  "doYouWantToResumeOpportunity": "Vil du gjenåpne denne henvendelsen?",
  "errorCommentEmpty": "Du må legge ved et notat.",
  "errorCouldNotGetAllForms": "Kunne ikke hente henvendelser.",
  "errorCouldNotGetForm": "Kunne ikke hente skjema.",
  "errorErrorBoundaryCouldNotShow": "Visning av henvendelse feilet. Vennligst ta kontakt med oss hvis dette skjer.",
  "errorINResponse": "Kunne ikke hente e-postsvar fra Innovasjon Norge.",
  "errorNoCounties": "Ingen fylker registrert.",
  "explanation.AddComment": "Her kan du legge til et notat til aktivitetsloggen. Dette kan være at et møte har blitt avholdt, ting å se på videre eller annet.",
  "explanation.Close1": "Hvis henvendelsen er ferdig behandlet, den kan ikke videresendes eller av andre grunner ikke kan behandles kan du velge å avslutte den.",
  "explanation.Close2": "Den vil da dukke opp under arkiv og du kan velge å gjenåpne den senere. Gi en begrunnelse på hvorfor den avsluttes.",
  "explanation.CustomerInformation": "Her finner du informasjon om kunden og bedriften som sendte inn henvendelsen. Du kan velge å legge til både bedrift og kunde i din ressursbase slik at du enkelt finner dem igjen senere.",
  "explanation.Forward": "Her velger du mottaker til denne henvendelsen blant andre som er med på En Vei Inn piloten. Når en henvendelsen videresendes lukkes den for deg, men du kan fremdeles se den i arkivet. Begrunnelsen vil vises for den som mottar henvendelsen.",
  "explanation.RegisterServices": "Her velger du hvilke tjenester du har gitt kunden som en del av behandlingen av henvendelsen. Disse blir da lagt til i aktivitetsloggen.",
  "explanation.Reopen": "Om du ønsker kan du velge å gjenåpne en henvendelse. Gi da en begrunnelse på hvorfor dere tar tak i denne henvendelsen igjen.",
  "feedbackFilter.Correct": "Korrekt",
  "feedbackFilter.Incorrect": "Feil",
  "feedbackFilter.Missing": "Mangler",
  "feedbackFilter.Title": "Filtrer etter tilbakemelding",
  "feedbackFromOtherActors": "Tilbakemeldinger fra andre aktører",
  "feedbacks": "Vurderinger",
  "feedback.sendWithoutSuggestion": "Send uten forslag",
  "filterByMunicipality": "Filtrer etter kommune",
  "fromMunicipality": "Fra kommune",
  "fullHistoric": "Full historikk",
  "getMoreOpportunities": "Hent flere henvendelser",
  "history.automaticReply": "Automatisk svar",
  "history.readEmail": "Les e-post",
  "history.readAutomaticReply": "Les automatisk svar",
  "history.readReply": "Les svar",
  "history.sentToCustomer": "Sendt til kunden",
  "history.sentToCustomerWithReply": "fra kunde i \"E-post til kunde\"",
  "history.sentToCustomerWithoutReply": "i \"E-post til kunde\"",
  "isUnderDevelopment": "er under utvikling",
  "missingOpportunityInfo": "Mangler informasjon om henvendelsen.",
  "municipalityFirstLineFor": "Førstelinjetjeneste for",
  "noCustomer": "Ingen kunde på henvendelsen.",
  "noHistoryFound": "Ingen historie funnet.",
  "noServicesAvailable": "Ingen tjenester tilgjengelig.",
  "noteToActor": "Notat til aktør",
  "onboarding.modal.header": "Kom i gang med Flerbedriftsportalen",
  "onboarding.modal.paragraph1": "Fullfør tre steg for å benytte portalen på best mulig måte",
  "onboarding.modal.paragraph2": "Følg steg for steg i sidemenyen til høyre",
  "onboarding.modal.skip": "Hopp over",
  "opportunities": "Henvendelser",
  "opportunities.getMoreOpportunities": "Henter flere henvendelser...",
  "opportunities.newOpportunities": "Det har kommet {{numberOfOpportunities}} nye henvendelser",
  "opportunities.newOpportunity": "Det har kommet én ny henvendelse",
  "opportunityDetails.And": "og",
  "opportunityDetails.Contract": "Avtale",
  "opportunityDetails.Phase": "Fase",
  "opportunityDetails.AdmissionDate": "Opptaksdato",
  "opportunityDetails.RegisteredDate": "Registreringsdato",
  "opportunityDetails.Advisor": "Rådgiver",
  "opportunityDetails.ClosedService": "Lukket tjeneste.",
  "opportunityDetails.CreationError": "Kunne ikke hente eller opprette henvendelse.",
  "opportunityDetails.ForwardedTo": "Videresendt til",
  "opportunityDetails.ReferredFrom": "Henvist fra",
  "opportunityDetails.ActorsWhoReferredToYou": "Aktører som har henvist til deg",
  "opportunityDetails.FirstLineServiceFor": "Førstelinje for {{municipality}}",
  "opportunityDetails.FoundNoOpportunities": "Fant ingen henvendelser.",
  "opportunityDetails.MunicipalitiesList": "Alle henvendelser fra:",
  "opportunityDetails.NoRegisteredMunicipalities": "Ingen registrerte kommuner.",
  "opportunityDetails.OtherServices": "andre tjenester",
  "opportunityDetails.RecommendedServices": "Anbefalte tjenester",
  "opportunityDetails.RegisteredServices": "Registrerte tjenester",
  "opportunityDetails.ResumedService": "Gjenåpnet tjeneste.",
  "opportunityDetails.AccessTo": "Disse har tilgang til henvendelsen:",
  "opportunityDetails.CompanyMissing": "Bedrift mangler",
  "opportunityDetails.NameMissing": "Navn mangler",
  "opportunityDetails.MunicipalityMissing": "Kommune mangler",
  "opportunityDetails.PhoneMissing": "Telefonnummer mangler",
  "opportunityDetails.EmailMissing": "E-post mangler",
  "opportunityDetails.Concept": "Konseptet",
  "opportunityDetails.WhatCustomerNeedsHelpWith": "Hva kunden trenger hjelp med",
  "opportunityDetails.ShowInCustomerRegister": "Vis i kunderegisteret",
  "opportunityDetails.OtherOpportunitiesFrom": "Andre henvendelser fra {{name}}",
  "opportunityDetails.NoOtherOpportunities": "{{name}} har ingen andre registrerte henvendelser",
  "opportunityDetails.ActorsWithAccess": "Aktører med tilgang til henvendelsen",
  "organizationAlreadyExists": "Organisasjonen finnes allerede i ressursbasen.",
  "recommendToast.Error": "Kunne ikke anbefale tjenester. Prøv igjen og kontakt oss hvis det vedvarer.",
  "recommendToast.Pending": "Sender anbefaling...",
  "recommendToast.Success": "Anbefaling sendt!",
  "referToast.Error": "Kunne ikke sende henvisningen. Prøv igjen og kontakt oss hvis det vedvarer.",
  "referToast.Error409": "Kan ikke sende henvisning fordi aktøren allerede har henvendelsen hos seg. Du kan fortsatt henvise til spesifikke tjenester.",
  "referToast.Pending": "Sender henvisning...",
  "referToast.Success": "Henvisning sendt!",
  "retrievingFromBrreg": "Henter fra BrReg...",
  "opportunitySearchInputPlaceHolder": "Søk etter henvendelse, navn eller kommune",
  "actorSearchInputPlaceHolder": "Søk etter aktørnavn, fylke eller kommune",
  "serviceSearchInputPlaceHolder": "Søk på tjenestenavn, aktørnavn eller kontaktperson",
  "providerType": "Aktørtype",
  "sentTo": "Henvist til",
  "serviceType": "Type tjeneste",
  "services.Displaying": "Viser",
  "services.OfTotal": "av totalt",
  "services.NoRecommendedOrRegisteredServices": "Du har ikke registrert eller anbefalt noen tjenester ennå.",
  "services.recommend.error.chooseOneService": "Du må velge minst én tjeneste.",
  "services.recommend.mailpage.actor.description": "Autogenerert e-post sendes ut til aktør",
  "services.recommend.mailpage.actor.title": "Du har mottatt en henvendelse på Flerbedriftsportalen",
  "services.recommend.mailpage.customer.description": "Autogenerert e-post sendes ut til kunde",
  "services.recommend.mailpage.customer.title": "Vi anbefaler disse tjenestene",
  "services.recommend.note.cannotSendToCustomerWarning": "Ingen kunde funnet på henvendelse så kan ikke sende mail til dem.",
  "services.recommend.note.informCustomer": "Ønsker du å informere kunden om anbefalte tjenester?",
  "services.recommend.note.noteToActor": "Notat til aktør",
  "services.recommend.note.noteToActorDescription": "Når du anbefaler tjenester får aktørene som tilbyr disse tjenestene et e-postvarsel og tilgang til henvendelsen. Notatet vises i Aktivitetslogg.",
  "services.recommend.note.noteToCustomer": "Notat til kunde",
  "services.recommend.note.noteToCustomerDescription": "Om du ønsker kan du sende en e-post til kunden med informasjon om anbefalte tjenester. Notatet til kunden vises i starten av e-posten og du har mulighet til å se det på forhånd i neste steg.",
  "services.recommend.result.header": "E-post er sendt og samarbeidet er startet",
  "services.recommend.result.text1": "Henvendelsen er delt med aktøren og samarbeidet er startet.",
  "services.recommend.result.text2": "Vi anbefaler enten å fortsette samarbeidet eller avslutte henvendelsen. Du finner alternativene i verktøylinjen når du lukker vinduet.",
  "services.recommend.steps.choose": "Velg tjeneste",
  "services.recommend.steps.chooseExplanation": "Du finner tjenestene du tilbyr i Legg til tjeneste eller Legg til notat.",
  "services.recommend.steps.preview": "Forhåndsvisning",
  "services.recommend.steps.writeNote": "Skriv notat",
  "services.RecommendedServices": "Anbefalte tjenester",
  "services.recommend.success": "Tjeneste anbefalt",
  "services.recommend.error": "Kunne ikke anbefale tjeneste.",
  "services.register.deliveredService": "Levert tjeneste",
  "services.register.deliveredServices": "Leverte tjenester",
  "services.register.deliveredServiceInfobox": "Dersom du ikke finner tjenesten du leter etter kan du registrere tjenester i Felles tjenestekatalogen.",
  "services.register.goToCommunityCatalogue": "Gå til Felles tjenestekatalog",
  "services.register.noRegisteredServices": "Det er ingen registrerte tjenester.",
  "services.edit.unpublished": "Tjenesten er avpublisert",
  "services.edit.draftDeleted": "Utkastet er slettet",
  "services.edit.serviceDeleted": "Tjenesten er slettet",
  "services.edit.edit": "Rediger tjeneste",
  "services.edit.unpublish": "Avpubliser tjeneste",
  "services.edit.delete": "Slett tjeneste",
  "services.edit.deleteDraft": "Slett utkast",
  "services.edit.editOrPublish": "Rediger og/eller publiser tjeneste",
  "services.edit.unpublishWarning": "Tjenesten vil bli satt til utkast. Du kan publisere den igjen senere.",
  "services.edit.deleteWarning": "Tjenesten vil slettes for godt.",
  "services.edit.deleteDraftWarning": "Utkastet vil slettes for godt.",
  "status.Active": "Aktiv",
  "status.Archived": "Arkivert",
  "status.Closed": "Lukket",
  "status.Forwarded": "Videresendt",
  "status.New": "Ny",
  "status.Opened": "Åpnet",
  "status.Received": "Mottat",
  "status.Referred": "Henvist",
  "status.ReOpened": "Gjenåpnet",
  "status.Shared": "Delt",
  "status.wip": "I arbeid",
  "status.FollowUpLater": "På vent",
  "status.AutoArchived": "Automatisk arkivert",
  "status.ReferredLater": "Ny henvisning fra IN",
  "status.EmailReceivedFromCustomer": "Svar",
  "status.EmailSentToCustomer": "Kunde kontaktet",
  "success.addService": "Tjenester har blitt lagt til i Aktivitetslogg.",
  "success.Comment": "Notatet er lagt til i Aktivitetslogg.",
  "tabs.Interplay": "Samhandling",
  "tabs.Log": "Aktivitetslogg",
  "tabs.OneWayIn": "Henvendelse",
  "tabs.Services": "Tjenester",
  "tabs.actor": "Aktør",
  "tabs.greenPlatform": "Grønn plattform",
  "thisOpportunity": "denne henvendelsen",
  "updateToast.Error": "Feil ved oppdatering av henvendelse. Vennligst prøv på nytt.",
  "updateToast.Pending": "Oppdaterer henvendelse...",
  "updateToast.Success": "Henvendelse oppdatert!",
  "reason": "Begrunnelse",
  "feedback.description": "Skriv inn hvorfor henvendelsen ikke er sendt riktig",
  "feedback.sentCorrectly": "Er denne hendevndelsen sendt riktig?",
  "goToMunicipalityView": "Gå til kommunevisning",
  "goToCountyView": "Fylkesvisning",
  "noRegisteredCounties": "Ingen registrerte fylker",
  "log.table.column.activity": "Aktivitet",
  "log.table.column.actor": "Aktør",
  "log.table.column.behandler": "Behandlers navn",
  "log.table.column.description": "Beskrivelse",
  "services.recommended": "Anbefalte tjenester",
  "services.delivered": "Leverte tjenester",
  "tab.Form": "Skjema",
  "tab.INResponseMail": "Svar fra Innovasjon Norge",
  "selectMunicipality": "Velg  kommune",
  "selectStatus": "Velg status",
  "noOpportunitiesFoundTitle": "Ingen henvendelser fra \"Én vei inn\"",
  "noOpportunitiesFoundDescription": "Det har ikke kommet henvendelser til behandling enda. Du kan gjerne oppfordre personer og bedrifter til å logge seg inn hos Innovasjon Norge og bruke tjenesten \"sjekk om du kan få hjelp\". Dette vil øke sannsynligheten for at det kommer nye henvendelser.",
  "noOpportunitiesFoundContactInfo": "Hvis du har spørsmål eller innspill så ta gjerne kontakt på <1>{{email}}</1>",
  "municipalityFirstLine": "Førstelinjetjenesten",
  "addOpportunities.banner": "Du kan nå legge til Henvendelser i Flerbedriftsportalen. Klikk her for å generere en lenke til En Vei Inn-skjemaet som du kan sende til kunden.",
  "addOpportunities.cta": "Lag en lenke til En Vei Inn-skjemaet",
  "addOpportunities.header": "Be kunden om å fylle ut en henvendelse",
  "addOpportunities.main": "Her kan du lage en lenke du kan dele med kunden. Lenken peker til skjemaet for En Vei Inn-henvendelser. Kunden logger seg inn med BankID og sender inn skjemaet. Innen ca. 2 virkedager får kunden et svar fra Innovasjon Norge, og henvendelsen blir henvist til deg.",
  "addOpportunities.seeMore.1": "Hensikt",
  "addOpportunities.seeMore.2": "Vi utforsker muligheter til å få samlet flere henvendelser dere får i Flerbedriftsportalen. I første omgang ønsker vi å bruke En Vei Inn-skjemaet til dette.",
  "addOpportunities.seeMore.3": "Fremtidens prosess",
  "addOpportunities.seeMore.4": "Vi holder på med et konsept som gjør at henvendelsene havner rett til dere, umiddelbart. En e-post kan bli sendt til kunden for å fylle ut skjemaet. Vi vil teste ut slike løsninger etter hvert som vi får innsikt og tilbakemeldinger fra dere.",
  "addOpportunities.referBack": "Ønsker du at kunden skal bli henvist <strong>tilbake til deg</strong> etter innsending av En Vei Inn-skjemaet?",
  "addOpportunities.submit": "Lag lenke",
  "addOpportunities.error": "Noe gikk galt når lenken ble laget. Vennligst prøv igjen senere.",
  "opportunity.update.error": "Klarte ikke å oppdatere henvendelsen",
  "status.setFollowUpLater": "Sett på vent",
  "status.setFollowUpLater.title": "Sett henvendelsen på vent",
  "status.setFollowUpLater.more": "Du kan følge opp henvendelsen senere. Skriv et notat til senere oppfølging. Notatet vises i Aktivitetslogg.",
  "status.setFollowUpLater.reminder": "Send meg en påminnelse på mail.",
  "status.setActive": "Sett i arbeid",
  "status.setActive.title": "Start behandlingen av henvendelsen igjen",
  "status.setActive.more": "Behandlingen av henvendelsen gjenopptas. Skriv et notat med begrunnelsen. Notatet vises i Aktivitetslogg.",
  "status.updateSuccess": "Status er oppdatert.",
  "opportunity.correctlyReferred": "Var det riktig av Én vei inn å sende dere denne henvendelsen?",
  "opportunity.feedback.doYouWantToGoToReferral": "Vil du gå til henvisning?",
  "opportunity.feedback.comment": "Fortell oss gjerne hvorfor det er riktig å henvise til denne/disse aktørene",
  "opportunity.feedback.wrongComment": "Fortell oss gjerne hvorfor det var feil å henvise denne til deg",
  "opportunity.feedback.goToReferral": "Gå til henvisning",
  "opportunity.feedback.selectedActors": "Du har valgt: ",
  "opportunity.feedback.option.geography": "Feil geografisk nedslagsfelt",
  "opportunity.feedback.option.tooFar": "Selskapet/Gründeren har kommet for langt",
  "opportunity.feedback.option.tooShort": "Selskapet/Gründeren har ikke kommet langt nok",
  "opportunity.feedback.option.notEnoughInnovation": "For lav innovasjonsgrad",
  "opportunity.feedback.option.wrongBusiness": "Feil bransje",
  "opportunity.feedback.option.other": "Annet",
  "opportunity.feedback.confirmation": "Hjelp oss gjerne med å henvise til de aktøren(e) du mener er riktig.",
  "opportunity.activeWithDeliveredServices": "Aktive henvendelser med leverte tjenester",

  "referral.title": "Henvisning",
  "referral.error.text": "Vennligst prøv på nytt senere. Dersom feilen vedvarer, ta kontakt.",
  "referral.notification.step1.error.noneSelected": "Du må velge én aktør å henvise til",
  "referral.notification.step2.error.noActorMessage": "Melding til aktør må fylles ut.",
  "referral.notification.step2.error.noCustomerMessage": "Melding til kunde må fylles ut.",
  "referral.notification.step3.error": "Vi kunne ikke sende henvisningen. Prøv igjen og hvis problemet gjenoppstår kontakt oss på ",
  "referral.notification.step3.error.receiverAlreadyHasCustomer": "Henvisningen ble ikke sendt siden mottaker allerede har kunden inne. Hvis du allikevel vil henvise til dem, kan du legge til tjenester i henvisningen.",
  "referral.steps.step1.text": "Steg 1: Velg aktør",
  "referral.steps.step2.text": "Steg 2: Skriv henvisning",
  "referral.steps.step3.text": "Steg 3: Send henvisning",
  "referral.navigationBar.step": "Steg {{currentStep}} av {{stepCount}}",
  "referral.navigationBar.step3.primaryButtonText": "Fullfør og send henvisning",
  "referral.referralSent.referralSent": "Henvisning er sendt",
  "referral.referralSent.sentDescription": "Aktøren(e) har fått tilsendt henvendelsen og e-postene er sendt.",
  "referral.referralSent.archiveDescription": "Du kan arkivere henvendelsen dersom du er ferdig med behandling.",
  "referral.referralSent.activityLogDescription": "Du kan fortsatt følge med henvendelsen fra Aktivitetslogg.",
  "referral.referralSent.primaryButton": "Gå til Arkivering",
  "referral.referralSent.secondaryButton": "Legg til oppfølging",
  "referral.referralSent.tertiaryButton": "Tilbake til første steg i Henvisning",
  "referral.sendReferral.sendReferralInfo": "Aktøren(e) vil få tilsendt henvendelsen via Flerbedriftsportalen og bli informert på e-post.",
  "referral.sendReferral.sendReferralInfoWithCustomer": "Aktøren(e) vil få tilsendt henvendelsen via Flerbedriftsportalen og både aktøren(e) og kunden blir informert på e-post.",
  "referral.sendReferral.referralError.header": "Henvisning feilet",
  "to": "Til: ",
  "opportunity.changeStatus": "Endre status:",
  "opportunity.feedback.intro.1": "Før dere snakker med kunden - gi oss et raskt svar",
  "opportunity.feedback.intro.2": "Var det riktig av Én vei inn å sende dere denne henvendelsen?",
  "opportunity.feedback.intro.3": "Svaret deres gjør at dere får flere riktige henvendelser. Det påvirker ikke hvordan dere behandler henvendelsen.",
  "opportunity.feedback.alsoReferredTo": "Innovasjon Norge har henvist til: ",
  "opportunity.feedback.correct.title": "Så bra! Burde Innovasjon Norge også henvist til flere?",
  "opportunity.feedback.incorrect": "Fortell oss hvorfor dere ikke skal ha denne henvendelsen",
  "opportunity.feedback.correct.text": "Her kan du velge hvilke andre aktører vi også burde henvist til. Del også gjerne tanker om henvisningen. Vi har ikke mulighet til å svare på tilbakemeldingen din, men bruker den til å forbedre oss.",
  "opportunity.feedback.answerSent": "Svar sendt",
  "opportunity.feedback.thankYou": "Takk for tilbakemeldingen!",
  "opportunity.feedback.forwardToAnotherActor": "Henvis gjerne denne henvendelsen videre til en annen aktør",
  "opportunity.table.filter.noMunicipality": "Uten kommune",
  "opportunity.addAdvisor.toastSuccess.title": "Tilordnet rådgiver",
  "opportunity.addAdvisor.toastSuccess.info": "Navnet til tilordnet rådgiver vil vises",
  "opportunity.addAdvisor.email.toastSuccess.title": "E-postvarsel er sendt",
  "opportunity.addAdvisor.email.toastSuccess.info": "Tilordnet rådgiver får et e-postvarsel",
  "opportunity.addAdvisor.toastError.title": "Kunne ikke tilordne rådgiver",
  "opportunity.addAdvisor.toastError.info": "Prøv igjen. Hvis problemet vedvarer, kontakt oss på support@enveiinn.no",
  "opportunity.addAdvisor.modal.title": "Tilordne rådgiver",
  "opportunity.addAdvisor.modal.infoText": "Du kan tilordne henvendelsen til en rådgiver i din organisasjon. Navnet til rådgiveren vil vises i henvendelsesoversikten. Hvis du ikke finner rådgiveren kan du invitere vedkommende til Flerbedriftsportalen.",
  "opportunity.addAdvisor.modal.invite": "Inviter en ny bruker via ",
  "opportunity.addAdvisor.modal.searchPlaceholder": "Søk etter rådgiver",
  "opportunity.addAdvisor.addButton": "Tilordne til rådgiver",
  "opportunity.addAdvisor.notAssigned": "Ikke tilordnet",
  "opportunity.addAdvisor.sendEmail": "Send e-postvarsel til rådgiveren",
  "advisor.label": "Rådgiver:",
  "advisor.tooltip": "Rådgiver",
  "advisor.currentlyAssigned": "Tilordnet rådgiver",
  "advisor.changeAdvisor": "Bytt rådgiver",
  "advisor.assignAdvisor": "Tilordne rådgiver",
  "opportunity.addAdvisor.dialog.sendEmailQuestion": "Ønsker du å varsle {{advisorName}} på epost?",
  "opportunity.addAdvisor.dialog.advisorFallback": "rådgiveren",
  "tabs.archive": "Arkiv",
  "tabs.active": "Aktive henvendelser",
  "batchArchive.archive": "Arkiver",
  "batchArchive.notification.error.part1": "Det har oppstått en ",
  "batchArchive.notification.error.error": "feil",
  "batchArchive.notification.error.part2": ". Vennlist prøv på nytt senere. Dersom feilen vedvarer, kontakt oss.",
  "batchArchive.toast.text.singular": "Du kan gjenåpne denne senere",
  "batchArchive.toast.text.plural": "Du kan gjenåpne disse senere",
  "batchArchive.toast.title.singular": "Du har arkivert {{count}} henvendelse",
  "batchArchive.toast.title.plural": "Du har arkivert {{count}} henvendelser",
  "batchArchive.modal.text.singular": "Henvendelsen blir arkivert, men kan åpnes igjen ved behov.",
  "batchArchive.modal.text.plural": "Henvendelsene blir arkivert, men kan åpnes igjen ved behov.",
  "batchArchive.modal.title": "Arkiver valgte henvendelser",
  "frontpage.notification.newOpportunities": "{{opportunityNumber}} uleste henvendelser",
  "frontpage.notification.newOpportunity": "1 ulest henvendelse",
  "frontpage.notification.opportunities": "{{opportunityNumber}} henvendelser",
  "frontpage.notification.opportunity": "1 henvendelse",
  "frontpage.actors": "Aktører i",
  "frontpage.actorTotal": "{{count}} aktører er registrert i flerbedriftsportalen per",
  "frontpage.howTo.header": "Slik behandler du Én vei inn-henvendelser",
  "frontpage.howTo.evaluateReferral.header": "Vurder om henvisningen er riktig",
  "frontpage.howTo.evaluateReferral.text": "Les henvendelsen og gi tilbakemelding på om den er henvist riktig til deg.",
  "frontpage.howTo.referral.header": "Henvis til andre aktører",
  "frontpage.howTo.referral.text": "Henvis til andre aktører hvis henvendelsen også er relevant for dem. Anbefal gjerne kunden tjenester som du mener passer for kunden.",
  "frontpage.howTo.services.header": "Synliggjør dine tjenester",
  "frontpage.howTo.services.text": "Legg til dine egne tjenester. Anbefal tjenester til kunden. Marker hvilke du har levert. Dette gjør dine tjenester mer synlig for andre aktører.",
  "frontpage.howTo.memory.header": "Bygg felles hukommelse",
  "frontpage.howTo.memory.text": "Oppdater henvendelsen med hvordan du har hjulpet kunden, slik at alle i virkemiddelapparatet kan bistå kunden på best mulig måte.",
  "frontpage.countyServices.none": "Ingen tjenester har blitt registrert i ditt fylke",
  "frontpage.statistics.recommended.total": "Totalt antall anbefalte tjenester",

  "customerFollowUp.myServices": "Mine tjenester ({{count}})",
  "customerFollowUp.goToMyServices": "Gå til Mine tjenester",
  "customerFollowup.cantFindService": "Finner du ikke tjenesten? Registrer den i Felles tjenestekatalog.",
  "customerFollowup.recommended": "Anbefalt",
  "customerFollowup.notRecommended": "Ikke anbefalt",
  "customerFollowUp.deliverService": "Lever tjeneste",

  "customerFollowUp.toast.error.title": "Det har oppstått en feil",
  "customerFollowUp.toast.error.text": "Prøv på nytt senere. Dersom feilen vedvarer, kontakt oss.",

  "customerFollowUp.addNote.toast.success.title": "Notat er lagt til",
  "customerFollowUp.addNote.toast.success.text": "Du finner notatet i aktivitetslogg",
  "customerFollowUp.addNote.toast.error.title": "Det har oppstått en feil",
  "customerFollowUp.addNote.toast.error.text": "Prøv på nytt senere. Dersom feilen vedvarer, kontakt oss.",
  "customerFollowUp.addNote.title": "Lag notat",
  "customerFollowUp.addNote.p1": "Her kan du legge til informasjon som er nyttig for deg selv og andre som jobber med denne henvendelsen. Notatet kan inneholde:",
  "customerFollowUp.addNote.li1": "Kommunikasjon med kunde som f.eks møte, e-post eller telefonsamtaler.",
  "customerFollowUp.addNote.li2": "Anbefalinger eller viktige avklaringer med kunden.",
  "customerFollowUp.addNote.li3": "Forslag til neste steg for kunden.",
  "customerFollowUp.addNote.p2": "Notatet lagres i aktivitetsloggen og bidrar til felles hukommelse og effektiv oppfølging. Vær tydelig og konkret.",

  "customerFollowUp.deliveredServices.title": "Leverte tjenester",
  "customerFollowUp.deliveredServices.p1": "Her velger du hvilke tjenester du har gitt kunden som en del av behandlingen av henvendelsen. Disse blir da lagt til i aktivitetsloggen.",
  "customerFollowUp.deliveredServices.servicesDelivered": "Tjeneste levert",
  "customerFollowUp.deliveredServices.delivered": "Levert",
  "customerFollowUp.notDelivered": "Ikke levert",
  "customerFollowUp.deliveredServices.modal.title": "Bekreft at du har levert tjenesten",
  "customerFollowUp.deliveredServices.modal.p1": "Hva er neste skritt for kunden?",
  "customerFollowUp.deliveredServices.modal.p2": "All informasjon blir lagt til i aktivitetsloggen og hjelper andre aktører som skal jobbe med denne henvendelsen.",
  "customerFollowUp.deliveredServices.modal.p3": "Hvis en annen aktør kunne ha hjulpet kunden, husk å henvis videre.",
  "customerFollowUp.deliveredServices.confirmDelivered": "Bekreft levert",
  "customerFollowUp.deliveredServices.toast.success.title": "Registrert levert tjeneste",
  "customerFollowUp.deliveredServices.toast.success.text": "Den vil bli lagt til i aktivitetslogg",

  "customerFollowUp.recommendServices.title": "Anbefal egne tjenester via e-post",
  "customerFollowUp.recommendServices.p1": "Her kan du anbefale dine egne tjenester til kunden.",
  "customerFollowUp.recommendServices.toast.success.title": "Anbefaling sendt",
  "customerFollowUp.recommendServices.modal.p1": "Autogenerert e-post som sendes ut til kunden. Teksten du fyller ut i innskrivingsfeltet vil sendes på samme plass som den er plassert.",
  "customerFollowUp.recommendServices.modal.emailPreview.textArea.placeholder": "Fyll inn eventuell tilleggsinformasjon her",
  "customerFollowUp.recommendServices.modal.p2": "Informasjonen blir lagt til i aktivitetsloggen og hjelper andre aktører som skal jobbe med denne henvendelsen.",
  "customerFollowUp.recommendServices.modal.button.primary": "Send anbefaling",
  "customerFollowUp.recommendServices.alert.title": "Nytt i Tjenestekatalogen",
  "customerFollowUp.recommendServices.alert.text": "Tjenester kan nå inneholde en kort tekst for å selge den inn til kunder. Rediger tjenestene dine for å ta dette i bruk.",

  "customerFollowUp.recommendedServices.title": "Tjenester andre aktører har anbefalt hos deg",
  "customerFollowUp.recommendedServices.p1": "Disse tjenestene har andre aktører anbefalt hos deg. Trykk på “Lever tjeneste” hvis du har levert tjenesten til kunden.",

  "referring.chosenActorForReferral": "Henvisning til:",
  "referring.servicesIn": "Tjenester i",
  "referring.serviceDescription": "Beskrivelse av tjenesten",
  "referring.deliveryTypes": "Hvordan tjenesten leveres",
  "referring.companyAge": "Krav til bedriftens alder",
  "companyAge.UnderThreeYears": "Under 3 år",
  "companyAge.UnderFiveYears": "Under 5 år",
  "companyAge.OverFiveYears": "Over 5 år",
  "companyAge.RelevantForAllAges": "Relevant for alle aldre",
  "companyAge.Unknown": "Ukjent",
  "referring.companySize": "Krav til bedriftens størrelse",
  "companySize.Small": "Liten",
  "companySize.Small.Description": "<50 årsverk",
  "companySize.Medium": "Middels",
  "companySize.Medium.Description": "50-250 årsverk",
  "companySize.Large": "Stor",
  "companySize.Large.Description": ">250 årsverk",
  "companySize.OtherCategoriesMayApply": "Andre kategorier kan gjelde",
  "companySize.Unknown": "Ukjent",
  "deliveryType.Connecting": "Kobling",
  "deliveryType.Egenkapital": "Egenkapital",
  "deliveryType.Fellesarrangementer": "Fellesarrangementer",
  "deliveryType.Foredrag": "Foredrag",
  "deliveryType.Garantier": "Garantier",
  "deliveryType.Kurs": "Kurs",
  "deliveryType.Lavrisikolaan": "Lavrisikolån",
  "deliveryType.Orientering": "Orientering",
  "deliveryType.Prosjektarbeid": "Prosjektarbeid",
  "deliveryType.Publikasjon": "Publikasjon",
  "deliveryType.Raadgivning": "Rådgivning",
  "deliveryType.Risikolaan": "Risikolån",
  "deliveryType.Selvbetjening": "Selvbetjening",
  "deliveryType.Tilskudd": "Tilskudd",
  "deliveryType.Unknown": "Ukjent",
  "referring.requirements": "Krav",
  "referring.selectedServices": "Tjenester du foreslår for aktøren:",
  "referring.servicesTable.selectedRowsSingular": "tjeneste valgt",
  "referring.servicesTable.selectedRowsPlural": "tjenester valgt",
  "referring.servicesTable.showInfo": "Vis informasjon om tjenesten",

  "referring.navigationBar.stepText.step0": "Velg aktøren du vil henvise til",
  "referring.navigationBar.stepText.step1": "Velg tjenester som er relevante for kunden (valgfritt)",
  "referring.navigationBar.stepText.step2": "Skriv melding til aktøren som mottar henvisningen",
  "referring.navigationBar.stepText.step3": "Send henvisningen",

  "referring.navigationBar.stepSubText.step2": "Du kan også sende epost til kunden",

  "review.addNote.success": "Du finner notatet under \"Vurderinger\"",

  "connectCompany": "Tilknytt bedrift",
  "connectCompany.modal.description.part1": "Hvis kunden har opprettet en bedrift, kan du knytte henvendelsen til denne. Du må kjenne bedriftsnavnet for å gjøre det.",
  "connectCompany.modal.description.part2": "Når henvendelsen er tilknyttet bedriften, får du tilgang til bedriftsinformasjonen.",
  "connectCompany.toast.success.title": "Bedrift tilknyttet",
  "connectCompany.toast.error.title": "Kunne ikke tilknytte bedriften",
  "connectCompany.toast.error.text": "Prøv igjen. Hvis problemet vedvarer, kontakt oss på support@enveiinn.no.",

  "changeStatusDropdown.label": "Status:",
  "changeStatusDropdown.tooltip": "Status",
  "changeStatusDropdown.note": "Notat",
  "changeStatusDropdown.noteIsRequired": "Notatet må fylles ut",
  "changeStatusDropdown.changingStatus": "Endrer status",
  "changeStatusDropdown.newStatus": "Ny status:",

  "changeStatusModal.changeStatus": "Endre status",
  "changeStatusModal.select.label": "Status",
  "changeStatusModal.select.placeholder": "Velg ny status",
  "changeStatusModal.toast.success.title": "Status endret",
  "changeStatusModal.toast.error.title": "Kunne ikke endre statusen",
  "changeStatusModal.toast.error.text": "Prøv igjen. Hvis problemet vedvarer, kontakt oss på support@enveiinn.no.",
  "changeStatusModal.mailReminder.checkbox.text": "Send meg en påminnelse på mail",
  "changeStatusModal.mailReminder.dateInput.label": "Påminnelse skal sendes",
  "changeStatusModal.description.archive": "Selv om henvendelsen vil bli arkivert kan den gjenåpnes senere ved behov.",
  "changeStatusModal.description.reOpen": "Behandlingen av henvendelsen gjenopptas. Skriv et notat med begrunnelsen. Notatet vises i Aktivitetslogg.",
  "changeStatusModal.description.followUpLater": "Du kan følge opp henvendelsen senere. Skriv et notat til senere oppfølging. Notatet vises i Aktivitetslogg.",
  "changeStatusModal.currentStatus": "Nåværende status",
  "nationWide": "Landsdekkende",
  "communication.sendEmail": "Send e-post",
  "communication.sendNewEmail": "Send ny e-post",
  "communication.sendEmailToCustomer": "Send e-post til kunden",
  "communication.emailLabel": "Send ny e-postmelding",
  "communication.emailThreadFallback.p1": "Vi jobber med å endre avsenderadressen for e-postene som sendes fra Flerbedriftsportalen. Foreløpig er adressen",
  "communication.emailThreadFallback.p2": "Kunder kan ikke se tidligere meldinger i e-posten, men de kan fortsatt svare direkte på e-posten du har sendt dem via Flerbedriftsportalen.",
  "communication.emailThreadFallback.p3": "Vi gjør løpende forbedringer i løsningen. Har du innspill eller spørsmål, hører vi gjerne fra deg.",
  "communication.emailThreadFallback.p4": "Takk for tålmodigheten!",
  "communication.newEmail.title": "Send ny e-post til kunde",
  "communication.newEmail.error.empty": "E-posten kan ikke være tom",
  "communication.newEmail.error.sendFailed": "Kan ikke sende e-post. Prøv igjen senere",
  "communication.newEmail.toast.title": "E-post sendt",
  "communication.newEmail.toast.text": "Du vil finne den i “Min innboks”",
  "statistics.statusMap": "Oversikt over statuser på henvendelser",
  "statistics.serviceDeliveryMap": "Leverte og anbefalte tjenester hos deg",
  "statistics.serviceDeliveryMap.delivered": "Levert",
  "statistics.serviceDeliveryMap.recommended": "Anbefalt",
  "statistics.numDeliveredServices": "Antall leverte tjenester",
  "statistics.numOptyForwarded": "Antall henvendelser henvist videre",
  "statistics.numOptyReceived": "Antall henvendelser mottatt",
  "statistics.numOptyReceivedCorrectly": "Antall henvendelser henvist riktig",
  "sponsors.Counties": "Fylkeskommunen (FK)",
  "sponsors.Norad": "Norad",
  "sponsors.DFD": "Digitaliserings- og forvaltningsdepartementet",
  "sponsors.FIN": "Finansdepartementet",
  "sponsors.KDD": "Kommunal- og distriktsdepartementet",
  "sponsors.KLD": "Klima- og miljødepartementet",
  "sponsors.KUD": "Kultur- og likestillingsdepartementet",
  "sponsors.KD": "Kunnskapsdepartementet",
  "sponsors.LMD": "Landbruks- og matdepartementet",
  "sponsors.NFD": "Nærings- og fiskeridepartementet",
  "sponsors.OED": "Energidepartementet",
  "sponsors.SD": "Samferdselsdepartementet",
  "sponsors.UD": "Utenriksdepartementet",
  "sponsors.Unknown": "Ukjent",

  "opportunityBoard.recommendServicesModal.title": "Anbefal egne tjenester",
  "opportunityBoard.recommendServicesModal.description": "Legg til en eller flere tjenester fra listen",
  "opportunityBoard.noServicesModal.title": "Du har ingen tjenester",
  "opportunityBoard.noServicesModal.description": "For å bruke denne funksjonen må du opprette en tjeneste.",
  "opportunityBoard.deliverServicesModal.title": "Lever egne tjenester",
  "opportunityBoard.deliverServicesModal.description": "Velg en eller flere tjenester fra listen",
  "opportunityBoard.deliverServicesModal.primaryButton": "Marker som levert",
  "opportunityBoard.deliverServicesModal.dateLabel": "Når ble tjenesten(e) levert?",

  "errorMessage.NoServicesSelected": "Du må velge minst én tjeneste.",
  "errorMessage.SomethingWentWrong": "Det har skjedd en feil. Prøv igjen senere",
  "errorMessage.FieldEmpty": "Feltet kan ikke være tomt",

  "toasts.activityLogUpdated": "Aktivitetsloggen har blitt oppdatert",
  "toasts.serviceDelivery.success.title": "Tjenestene er markert som levert",

  "tooltip.addAdvisor": "Legg til rådgiver",
  "tooltip.changeAdvisor": "Endre rådgiver",

  "noFiltersAvailable": "Ingen tilgjengelige filter",
  "filterByKeyword": "Filtrer med nøkkelord",

  "refer.dialog.ariaLabel": "Henvis muligheten videre",
  "refer.dialog.selectActor": "Velg aktøren du vil henvise til",
  "refer.validation.noActorChosen": "Du må velge en aktør for å kunne henvise videre",
  "refer.dialog.actorAlreadyHasOpportunity": "<bold>{{name}}</bold> har allerede henvendelsen hos seg. Velg en eller flere tjenester hos dem du vil anbefale.",
  "refer.dialog.chooseService": "Velg tjeneste hos <bold>{{name}}</bold> (valgfritt)",
  "refer.validation.noServiceChosen": "Du må velge minst én tjeneste",
  "refer.validation.messageEmpty": "E-posten kan ikke være tom",
  "refer.dialog.sendReferral": "Send henvisning",
  "refer.dialog.writeMessageToActor": "Send e-post til {{name}}",
  "refer.dialog.customerEmailPrompt.title": "Ønsker du også å sende e-post til kunden?",
  "refer.dialog.customerEmailPrompt.description": "Her kan du opplyse kunden om at henvendelsen deres er sendt videre",
  "refer.dialog.writeMessageToCustomer": "Send e-post til kunde",
  "refer.dialog.archivePrompt.title": "Ønsker du å arkivere henvendelsen?",
  "refer.dialog.archivePrompt.error": "Kunne ikke arkivere. Prøv igjen senere."
}
